import React, { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import { toNumber } from 'lodash';

import { DEFAULT_DATE_FORMAT, EMPTY_FIELD_VALUE } from '@/common/constants';
import { LockboxAmountInput } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxForm/components';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';
import { formatCurrency } from '@/utils';

import useLockboxOutboundTOACloseAccountFields from './useLockboxOutboundTOACloseAccountFields';

const useLockboxInboundTOAFields = () => {
  const { originalLockbox } = useLockboxDetailsStore();
  const { lockboxOutboundTOACloseAccountFields } = useLockboxOutboundTOACloseAccountFields();

  const lockboxIOutboundTOAFields = useMemo(() => [
    {
      type: FieldTypes.Text,
      name: 'employeeName',
      label: 'Employee name',
      value: originalLockbox?.ocr?.employeeName || EMPTY_FIELD_VALUE,
    },
    {
      type: FieldTypes.Text,
      name: 'ssn',
      label: 'SSN',
      value: originalLockbox?.ocr?.ssn || EMPTY_FIELD_VALUE,
    },
    {
      type: FieldTypes.Text,
      name: 'hsaAccountNumber',
      label: 'HSA account number',
      value: originalLockbox?.ocr?.accountNumber || EMPTY_FIELD_VALUE,
    },
    {
      type: FieldTypes.Text,
      name: 'dateOfBirth',
      label: 'Date of birth',
      value: originalLockbox?.ocr?.birthDate
        ? dayjs(originalLockbox?.ocr?.birthDate).format(DEFAULT_DATE_FORMAT) 
        : EMPTY_FIELD_VALUE,
    },
    {
      type: FieldTypes.Node,
      name: 'amount',
      label: 'Amount',
      value: originalLockbox?.amount
        ? formatCurrency(toNumber(originalLockbox?.amount))
        : EMPTY_FIELD_VALUE,
      node: <LockboxAmountInput />,
    },
    ...lockboxOutboundTOACloseAccountFields,
  ], [originalLockbox, lockboxOutboundTOACloseAccountFields]);

  return {
    lockboxIOutboundTOAFields: lockboxIOutboundTOAFields as Field[],
  };
};

export default useLockboxInboundTOAFields;
